const parseSectionJson = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const section = doc.querySelector('.shopify-section');
  const sectionData = JSON.parse(section.innerHTML);

  return sectionData;
};

export default parseSectionJson;
